import { isCalculatableType } from '../../utils';
import { TokenComposeError } from '../../errors';
import { IAstNode } from '../../typings/ast-node';
import { IDeclarationToken } from '../../typings/token';
import { composeFunctions } from './function';
import { composeBrackets } from './brackets';
import { composeParenthesis } from './../composes/parenthesis';
import { composeLogicNot } from './logic-not';
import { composeArithmetic } from './arithmetic';
import { composeComparison } from './comparison';
import { composePathDirection } from './path-direction';


export default function compose(astNodes: IAstNode[]): any {
  if (astNodes.length === 0) {
    return;
  }
  if (astNodes.length === 1) {
    const astNode = astNodes[0];
    if (astNode.type === 'Temporary') {
      if (!isCalculatableType(astNode.token.type!) && !(astNode.token as IDeclarationToken).isDeclaration) {
        throw new TokenComposeError('invalid-token-start', '无效的表达式', astNode.token.position);
      }
      (astNode as IAstNode).type = astNode.token.isAtom ? 'Atom' : astNode.type;
    }
    return astNode;
  }


  // 中括号
  composeBrackets(astNodes, compose);

  // 函数
  composeFunctions(astNodes, compose);

  // 小括号
  composeParenthesis(astNodes, compose);

  // 逻辑非
  composeLogicNot(astNodes, compose);

  // 带方向的数据模型路径
  composePathDirection(astNodes, compose);

  // 四则运算乘除取余
  composeArithmetic(astNodes, ['*', '/', '%'], compose);

  // 四则运算加减
  composeArithmetic(astNodes, ['+', '-'], compose);

  // >、<、BEGIN WITH、END WITH 等
  composeComparison(astNodes, [
    'BETWEEN',
    'NOT-CONTAIN', 'CONTAIN', 'BEGIN-WITH', 'END-WITH',
    'GREAT-THAN', 'GREAT-THAN-EQUAL', 'LESS-THAN', 'LESS-THAN-EQUAL',
    'NOT-IN', 'IN',
    'INCLUDE-ANY', 'INCLUDE-ALL', 'EXCLUDE-ANY', 'EXCLUDE-ALL',
    'ANY-GREAT-THAN', 'ANY-GREAT-THAN-EQUAL', 'ANY-LESS-THAN', 'ANY-LESS-THAN-EQUAL', 'ANY-EQUAL', 'ANY-NOT-EQUAL', 'ANY-BETWEEN',
    'ALL-GREAT-THAN', 'ALL-GREAT-THAN-EQUAL', 'ALL-LESS-THAN', 'ALL-LESS-THAN-EQUAL', 'ALL-EQUAL', 'ALL-NOT-EQUAL', 'ALL-BETWEEN',
    'ANY-CONTAIN', 'ANY-NOT-CONTAIN', 'ANY-BEGIN-WITH', 'ANY-END-WITH',
    'ALL-CONTAIN', 'ALL-NOT-CONTAIN', 'ALL-BEGIN-WITH', 'ALL-END-WITH',
    'IS', 'IS-NOT', 'ANY-IS', 'ANY-IS-NOT', 'ALL-IS', 'ALL-IS-NOT'
  ], compose);

  // ==、!=
  composeComparison(astNodes, ['EQUAL', 'NOT-EQUAL'], compose);

  // 逻辑与、逻辑或
  composeComparison(astNodes, ['AND', 'OR'], compose);

  if (astNodes.length > 1) {
    throw new TokenComposeError('invalid-expression', '无效的表达式', astNodes[1].token!.position);
  }

  return astNodes[0];
}
